import Aos from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { QueryClient, QueryClientProvider } from "react-query";
import "./App.scss";
import { AuthRouter } from "./pages/AuthRouter";
import ScrollToTop from "react-scroll-to-top";
import { useLocation } from 'react-router-dom';

function App() {
  const location = useLocation();
  const queryClient = new QueryClient();
  useEffect(() => {
    Aos.init({ offset: 20 });
  }, []);

    useEffect(() => {
        // Send page view event on route change
        if (window.gtag) {
            window.gtag('config', 'G-SP5KF19S49', {
                'page_path': location.pathname + location.search,
                'page_location': window.location.href,
                'page_title': document.title
            });
        }
    }, [location]);
  return (
    <QueryClientProvider client={queryClient}>
      <Toaster position="top-right " />
      <AuthRouter />
      <ScrollToTop smooth color="white" />
    </QueryClientProvider>
  );
}

export default App;
